// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { PAGINATION_DEFAULT_VALUE } from '../defaultValue';

const api = new APICore();

type Query = {
    currentPage: number,
    pageSize: number,
    search: string,
};

function getAllManifests(query: Query, returnImage: Boolean): any {
    const page = query.currentPage || PAGINATION_DEFAULT_VALUE.currentPage;
    const page_size = query.pageSize || PAGINATION_DEFAULT_VALUE.pageSize;

    let baseUrl = config.MANIFESTS_URL;

    if (typeof query === 'string') {
        baseUrl += `?${query}`;
    }

    const queryParam = {
        page: page.toString(),
        page_size: page_size.toString(),
    };

    return api.get(`${baseUrl}`, typeof query === 'object' ? queryParam : undefined, { headers: { 'return-image': returnImage } });
}

function createManifest(manifestRequest: any, returnImage: Boolean): any {
    const baseUrl = config.MANIFESTS_URL;
    return api.create(`${baseUrl}`, manifestRequest, { headers: { 'return-image': returnImage } });
}

function getManifest(manifestId: string, returnImage: Boolean): any {
    const baseUrl = config.MANIFESTS_URL;
    return api.get(`${baseUrl}/${manifestId}`, undefined, { headers: { 'return-image': returnImage } });
}

export { getAllManifests, createManifest, getManifest };
